import { createContext, useCallback } from "react";
import React from "react";
const GlobalContext = createContext();

const getHeaderImages = () => {
  try {
    return JSON.parse(localStorage.getItem("headerImages") || "[]");
  } catch {
    return [];
  }
};

export const GlobalContextProvider = ({ children }) => {
  const setHeaderImages = useCallback((images) => {
    localStorage.setItem("headerImages", JSON.stringify(images));
  }, []);

  return (
    <GlobalContext.Provider
      value={{
        get headerImages() {
          return getHeaderImages();
        },
        setHeaderImages,
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};

export const useGlobalContext = () => React.useContext(GlobalContext);
